import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const SetPFPIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			viewBox="0 0 24 24"
			onClick={props.onClick}
			fill="none"
			className={props.className}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<g opacity="0.8">
				<path
					d="M12 22C17.47 22 22 17.47 22 12C22 6.54 17.46 2 11.99 2C6.53 2 2 6.54 2 12C2 17.47 6.54 22 12 22ZM12 11.7C10.57 11.69 9.4 10.48 9.4 8.85C9.4 7.34 10.57 6.09 12 6.09C13.43 6.09 14.6 7.34 14.6 8.85C14.6 10.48 13.43 11.71 12 11.7ZM7.38 17.14C6.97 17.14 6.78 16.87 6.78 16.5C6.78 15.4 8.45 12.53 12 12.53C15.55 12.53 17.22 15.4 17.22 16.5C17.22 16.87 17.03 17.14 16.62 17.14H7.38Z"
					fill="white"
				/>
			</g>
		</svg>
	)
}

export default SetPFPIcon
